module.exports = __webpack_public_path__ + "static/media/stepper-compile.9b7cc569.svg";